import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { useGenerateTokenService } from 'app/utils/services/generateTokenService';

const useLogin = () => {
  const { t } = useTranslation();
  const [value, setValue] = useState(0);
  const [currentLang, setCurrentLang] = useState('');
  const { lang } = useParams();
  const location = useLocation();
  const tab = location.state;

  useEffect(() => {
    if (tab !== null) {
      setValue(tab.tab);
    }
  }, []);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const { isLoadingToken, dataToken, errorToken, tokenMutation } = useGenerateTokenService();

  useEffect(() => {
    setCurrentLang(localStorage.getItem('i18nextLng'));
  }, [lang]);

  useEffect(() => {
    if (currentLang !== '') {
      tokenMutation(currentLang);
    }
  }, [currentLang]);

  return {
    t,
    value,
    handleChange,
  };
};

export default useLogin;
